import React from 'react';

export default function TableSolicitudes(props) {
  // Encabezados por defecto si Strapi no envía datos
  const defaultColumns = [
    { id: 'id', label: 'ID' },
    { id: 'programa', label: 'Programa' },
    { id: 'nivel', label: 'Nivel' },
    { id: 'periodo', label: 'Periodo' },
    { id: 'estatus', label: 'Estatus' },
    { id: 'accion', label: 'Acción' }
  ];

  // Usar columnas de Strapi si están disponibles, sino usar las por defecto
  const columns = (props.columns && Array.isArray(props.columns) && props.columns.length > 0) 
    ? props.columns 
    : defaultColumns;

  return (
    <table className="table-inicio">
      <thead>
        <tr>
          {columns.map(col => (
            <td key={col.id}>{col.label}</td>
          ))}
        </tr>
      </thead>

      <tbody>
        {props.lista?.map((item, i) => {
          return (
            <tr key={i}>
              <td className="mainColumn">{item.numero}</td>
              <td className="mainColumn">
                {props.translatedCarreras?.[item.carreraNombre] || item.carreraNombre}
              </td>
              <td>
                {props.translatedNiveles?.[item.nivelAcademicoNombre] || item.nivelAcademicoNombre}
              </td>
              <td className="colFontBlue">
                {props.translatedPeriodos?.[item.periodo] || item.periodo}
              </td>
              <td
                className={`mainColumn ${
                  item.estadoId === 9 ||
                  item.estadoId === 10 ||
                  item.estadoId === 11 ||
                  item.estadoId === 19
                    ? 'statusGreen'
                    : item.estadoId === 8
                    ? 'statusYellow'
                    : item.estadoId === 7
                    ? 'statusRed'
                    : 'normalStatus'
                }`}
              >
                {props.translatedEstados?.[item.estadoNombre] || item.estadoNombre}
              </td>
              <td>
                <button
                  className="btnNotificacion"
                  onClick={() => {
                    props.handleViewBtn(item.solicitudId, item.numero);
                  }}
                >
                  <i className="material-icons"></i>
                </button>
                {item.estadoId === 7 ||
                item.estadoId === 8 ||
                item.estadoId === 17 ||
                item.estadoId === 20 ? (
                  <>
                    <button
                      className="btnNotificacion"
                      onClick={() => {
                        props.handleEditButton(item.solicitudId);
                      }}
                    >
                      <i className="material-icons"></i>
                    </button>

                    <button
                      className="btnNotificacion"
                      onClick={() => {
                        props.handleRemoveBtn(item.solicitudId);
                      }}
                    >
                      <i className="material-icons"></i>
                    </button>
                  </>
                ) : null}
              </td>
            </tr>
          );
        })}
      </tbody>
    </table>
  );
}
